import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "dropdown", "userMenu"]

  connect() {
    this.scrollHandler = () => {
      this.element.classList.toggle("scrolled", window.scrollY > 10)
    }
    this.outsideClickHandler = (event) => {
      if (this.hasUserMenuTarget && !this.userMenuTarget.contains(event.target)) {
        this.userMenuTarget.classList.remove("open")
      }
    }
    window.addEventListener("scroll", this.scrollHandler)
    document.addEventListener("click", this.outsideClickHandler)
  }

  disconnect() {
    window.removeEventListener("scroll", this.scrollHandler)
    document.removeEventListener("click", this.outsideClickHandler)
  }

  toggleMobile() {
    this.menuTarget.classList.toggle("show")
  }

  toggleDropdown(event) {
    if (window.innerWidth <= 768) {
      event.preventDefault()
      const dropdown = event.currentTarget.closest(".dropdown")
      this.dropdownTargets.forEach(d => {
        if (d !== dropdown) d.classList.remove("open")
      })
      dropdown.classList.toggle("open")
    }
  }

  toggleUserMenu(event) {
    event.stopPropagation()
    this.userMenuTarget.classList.toggle("open")
  }
}
